import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Avatar,
  Rating
} from '@mui/material';

// --- Testimonial Data ---
// In a real app, this would likely come from an API.
const testimonialsData = [
  {
    name: 'Jane Doe',
    title: 'CEO, Innovate Inc.',
    testimonial: "f-ai has completely transformed our financial workflow. What used to take days of manual data entry is now done in minutes. It's accurate, intuitive, and has freed up so much time for us to focus on growing the business.",
    avatar: 'https://placehold.co/100x100/EBF4FF/4A4A4A?text=JD',
    rating: 5,
  },
  {
    name: 'John Smith',
    title: 'Founder, Tech Startups LLC',
    testimonial: "As a small business owner, I wear many hats. The accounting hat was always the most stressful. f-ai acts like a dedicated member of my team, providing clear insights and flawless reports. I can't imagine running my business without it.",
    avatar: 'https://placehold.co/100x100/EBF4FF/4A4A4A?text=JS',
    rating: 5,
  },
  {
    name: 'Emily White',
    title: 'Freelance Consultant',
    testimonial: "Finally, an accounting assistant that understands the complexities of freelance finances. f-ai makes tax season a breeze and helps me track my expenses effortlessly throughout the year. It's a game-changer!",
    avatar: 'https://placehold.co/100x100/EBF4FF/4A4A4A?text=EW',
    rating: 5,
  },
];


// --- Main Testimonials Component using Material-UI ---
const Testimonials = () => {
  return (
    <Box sx={{ bgcolor: 'grey.100', py: 8 }}>
      <Container maxWidth="lg">
        {/* Header section */}
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography variant="h4" component="h2" fontWeight="bold" gutterBottom>
            Trusted by Businesses Worldwide
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ maxWidth: '600px', mx: 'auto' }}>
            See how f-ai is helping businesses like yours save time, reduce errors, and make smarter financial decisions.
          </Typography>
        </Box>

        {/* Testimonials Grid */}
        <Grid container spacing={4}>
          {testimonialsData.map((testimonial, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', borderRadius: 2, boxShadow: 3 }}>
                <CardContent sx={{ flexGrow: 1, p: 3 }}>
                   <Rating name="read-only" value={testimonial.rating} readOnly sx={{ mb: 2 }} />
                  <Typography variant="body1" sx={{ fontStyle: 'italic', mb: 3 }}>
                    "{testimonial.testimonial}"
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', mt: 'auto' }}>
                    <Avatar src={testimonial.avatar} alt={testimonial.name} sx={{ mr: 2, width: 56, height: 56 }} />
                    <Box>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {testimonial.name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {testimonial.title}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Testimonials;